// extracted by mini-css-extract-plugin
export default {"page-content":"scheduled_page-content__Z9Xgx"};